/**
 * Constants for the Onboarding Modal
 */
import {
  OnboardingFormData,
  TouchedFields,
  ProvisioningComponent,
} from './types';

/** Event type constants matching backend EventType enum */
export const EVENT_TYPES = {
  APPLICATION: 'app-creation',
  GITHUB_REPO: 'github-repo',
  AD_GROUPS: 'ad-groups',
  CNAP_TENANCY: 'cnap-tenancy',
} as const;

/** Step labels for the onboarding wizard */
export const STEPS = [
  'Welcome to Experimental Onboarding',
  'Review',
  'Provisioning',
];

/** Initial values for the onboarding form */
export const initialFormData: OnboardingFormData = {
  name: '',
  description: '',
  identifier: '',
};

/** Initial state for field touch tracking */
export const initialTouchedState: TouchedFields = {
  name: false,
  description: false,
  identifier: false,
};

/** Initial state for provisioning components */
export const initialProvisioningComponents: ProvisioningComponent[] = [
  {
    id: EVENT_TYPES.APPLICATION,
    name: 'Application Creation',
    status: 'pending',
    progress: 0,
  },
  {
    id: EVENT_TYPES.GITHUB_REPO,
    name: 'GitHub Repository Provisioning',
    status: 'pending',
    progress: 0,
  },
  {
    id: EVENT_TYPES.AD_GROUPS,
    name: 'AD Group Provisioning',
    status: 'pending',
    progress: 0,
  },
  {
    id: EVENT_TYPES.CNAP_TENANCY,
    name: 'CNAP Tenancy Provisioning',
    status: 'pending',
    progress: 0,
  },
];
